import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Client } from 'src/app/models';
import { ENV_CONFIG } from 'src/bin/env.config';
@Component({
  selector: 'smr-client-item',
  templateUrl: './client-item.component.html',
  styleUrls: ['./client-item.component.scss']
})
export class ClientItemComponent {
  @Input() client: Client;

  @Output() clientSelect = new EventEmitter<Client>();

  public BOOKING_PHOTO_ROOT: string;

  public THUMBNAIL_PHOTO_ROOT: string;

  constructor() {
    this.BOOKING_PHOTO_ROOT = ENV_CONFIG.BOOKING_PHOTO_ROOT;
    this.THUMBNAIL_PHOTO_ROOT = ENV_CONFIG.THUMBNAIL_PHOTO_ROOT;
  }

  public onClientSelect() {
    this.clientSelect.emit(this.client);
  }
}
